module.exports = __webpack_public_path__ + "static/email-2-fcce04e54611cf635ae02e3de32f5349.jpg";